<div class="container">
  <div class="row">
    <ng-container *ngFor="let attachment of attachments">
      <div class="col-6">
        <div class="global-card p-2 mt-3" (click)="viewAttachment(attachment)" role="button">
          <div class="body">
            <img [src]="filePath + attachment?.path+'/'+ attachment?.attachmentName"
                        onerror="this.src='assets/img/empt-img.png'" class="rounded-3" width="100%" height="100%" alt="Provider-img">
            <h2 class="fs-6 text-dark-color fw-bold mt-3">{{ attachment.attachmentName }}</h2>
            <p class="mt-2 text-desc-color small mb-0">{{attachment.creationTime | momentPipe : "DD-MM-YYYY, hh:mm a"}}</p>
            <p class="mt-1 text-desc-color small mb-1">{{ attachment.creator }}</p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <!-- <ul class="list-group mt-4">
    <li *ngFor="let attachment of attachments"
      class="list-group-item list-group-item-action flex-column align-items-start" (click)="viewAttachment(attachment)">
      <div class="d-flex w-100 justify-content-between">
        <h5 class="mb-1">
          <i class="mx-1" [ngClass]="getIconClass(getFileExtension(attachment.attachmentName))"></i>
          <span>{{ attachment.attachmentName }}</span>
        </h5>
        <small>{{attachment.creationTime | momentPipe : "DD-MM-YYYY, hh:mm a"}}</small>
      </div>
      <small>{{ attachment.creator }}</small>
    </li>
  </ul> -->
</div>
